import React, { useState } from "react";

import { Row, Col, FormControl, Checkbox } from "react-bootstrap";

import EditCoachPoolContext from "../../../../contexts/EditCoachPoolContext";
import MultiFilterContext from "../../../../contexts/MultiFilterContext";

import Form from "./Form";
import Filters from "./Filters";
import Table from "./Table";
import Actions from "./Actions";

export default function Index({ coachPool, coachSelected, backUrl }) {
  return (
    <EditCoachPoolContext
      coachPool={coachPool}
      coachSelected={coachSelected}
      backUrl={backUrl}
    >
      <MultiFilterContext>
        <div className="wrapper_assestment invite_wrapper">
          <Form />
          <Filters />
          <div className="mt20">
            <Table />
          </div>
          <Actions />
        </div>
      </MultiFilterContext>
    </EditCoachPoolContext>
  );
}
